// 사용자 화면에 노출되는 영업안내 카드.
// 메인 화면/카트 화면 상단에 부착한다. 운영설정이 비어 있으면 안내 문구 없이 숨긴다.

import {
  OPEN_STATUS_REASON_LABEL_KO,
  WEEKDAYS_ORDERED,
  WEEKDAY_LABEL_KO,
  type StoreSettingsDto,
  type OpenStatus,
} from "@oo/shared";

interface Props {
  settings: StoreSettingsDto;
  openStatus: OpenStatus;
  // 예약 가능 슬롯이 하나라도 있으면 안내 문구를 함께 노출한다.
  hasReservation: boolean;
}

// 오늘 영업시간을 짧게 표시한다.
function todayHoursText(settings: StoreSettingsDto, now: Date): string {
  const wd = WEEKDAYS_ORDERED[now.getDay() === 0 ? 6 : now.getDay() - 1];
  const hours = wd ? settings.weeklyHours[wd] : null;
  if (!hours) {
    return "오늘은 휴무";
  }
  return `오늘 ${WEEKDAY_LABEL_KO[wd ?? "mon"]} ${hours.open} ~ ${hours.close}`;
}

// 매장 영업 상태 안내 카드.
export default function StoreStatusCard({ settings, openStatus, hasReservation }: Props) {
  // 화면에 노출할 사유 라벨.
  const reasonLabel = OPEN_STATUS_REASON_LABEL_KO[openStatus.reason];
  const isOpen = openStatus.isOpen;
  return (
    <section
      className={`rounded-lg border p-3 text-sm ${
        isOpen ? "border-success-600/30 bg-success-50" : "border-warning-600/30 bg-warning-50"
      }`}
    >
      <div className="flex items-baseline justify-between gap-2">
        <span className={`font-semibold ${isOpen ? "text-success-700" : "text-warning-700"}`}>
          {reasonLabel}
        </span>
        <span className="text-xs text-ink-600">{todayHoursText(settings, new Date())}</span>
      </div>
      {!isOpen && hasReservation ? (
        <p className="mt-1 text-xs text-warning-700">
          원하시는 일자/시간으로 예약 주문이 가능합니다.
        </p>
      ) : null}
      {settings.noticeText ? (
        <p className="mt-1 whitespace-pre-wrap text-xs text-ink-700">{settings.noticeText}</p>
      ) : null}
    </section>
  );
}
